import React, { useState } from 'react';
import { useAuth } from './AuthContext';
// Стили импортируются из App.css через глобальный импорт
// import './App.css'; // Если не импортирован глобально

const Login = ({ onRegisterClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, authError } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        {/* Левая панель - информация о платформе */}
        <div className="auth-info-panel">
          <div className="auth-brand">
            <div className="brand-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#brandGrad)" stroke="white" strokeWidth="2"/>
                <text x="24" y="32" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" fontFamily="system-ui">1С</text>
                <defs>
                  <linearGradient id="brandGrad" x1="0" y1="0" x2="48" y2="48">
                    <stop offset="0%" stopColor="#667eea"/>
                    <stop offset="100%" stopColor="#764ba2"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h1 className="brand-title">1С в LXC</h1>
            <p className="brand-subtitle">Платформа нового поколения</p>
            <div className="brand-badge">
              <span className="badge-mvp">MVP</span>
              <span className="badge-status">Proof-of-Concept</span>
            </div>
          </div>

          <div className="auth-features">
            <h3 className="features-title">Возможности платформы</h3>
            <ul className="features-list">
              <li>
                <span className="feature-icon">🚀</span>
                <span className="feature-text">Создание контейнеров для 1С</span>
              </li>
              <li>
                <span className="feature-icon">📦</span>
                <span className="feature-text">Автоматическая установка платформы 1С</span>
              </li>
              <li>
                <span className="feature-icon">🗄️</span>
                <span className="feature-text">Управление базами данных PostgreSQL</span>
              </li>
              <li>
                <span className="feature-icon">📊</span>
                <span className="feature-text">Мониторинг в реальном времени</span>
              </li>
              <li>
                <span className="feature-icon">🔄</span>
                <span className="feature-text">Автоматическое резервное копирование</span>
              </li>
              <li>
                <span className="feature-icon">⚡</span>
                <span className="feature-text">Плотность 30-50 контейнеров на сервер</span>
              </li>
            </ul>
          </div>

          <div className="auth-footer-info">
            <div className="footer-badges">
              <span className="footer-badge">📍 Один хост</span>
              <span className="footer-badge">🔄 Q1: Отказоустойчивость</span>
              <span className="footer-badge">🌍 Q2: Геораспределение</span>
            </div>
            <p className="footer-version">Версия 0.1.0 · MVP</p>
          </div>
        </div>

        {/* Правая панель - форма входа */}
        <div className="auth-form-panel">
          <div className="auth-card">
            <div className="auth-header">
              <h2 className="auth-title">Добро пожаловать!</h2>
              <p className="auth-subtitle">Войдите в свою учётную запись</p>
            </div>
            
            {authError && (
              <div className="auth-error">
                <i className="fas fa-exclamation-circle"></i>
                <span>{authError}</span>
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">
                  <i className="fas fa-envelope"></i>
                  Email
                </label>
                <div className="input-wrapper">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="user@company.ru"
                    required
                    disabled={loading}
                    className={email ? 'filled' : ''}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="password">
                  <i className="fas fa-lock"></i>
                  Пароль
                </label>
                <div className="input-wrapper password-wrapper">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Введите пароль"
                    required
                    disabled={loading}
                    className={password ? 'filled' : ''}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>
              
              <div className="form-options">
                <label className="remember-me">
                  <input type="checkbox" />
                  <span>Запомнить меня</span>
                </label>
                <a href="#" className="forgot-password">Забыли пароль?</a>
              </div>
              
              <button 
                type="submit" 
                className="auth-submit-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Вход...
                  </>
                ) : (
                  <>
                    <span>Войти</span>
                    <i className="fas fa-arrow-right"></i>
                  </>
                )}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Нет аккаунта?{' '}
                <button 
                  className="auth-link" 
                  onClick={onRegisterClick}
                  disabled={loading}
                >
                  Зарегистрироваться
                </button>
              </p>
            </div>

            <div className="auth-system-info">
              <div className="system-status">
                <span className="status-dot"></span>
                <span className="status-text">Система работает</span>
              </div>
              <div className="system-metrics">
                <span>🖥️ 1 хост</span>
                <span>📦 3 контейнера</span>
                <span>📊 98% доступности</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;